const DEFAULT_LOCALE = "en-US";

export function getLocaleOptions(inheritFrom) {
    const options = [
        { Key: "af-ZA", Value: "South Africa (Afrikaans)" },
        { Key: "ar-AE", Value: "U.A.E." },
        { Key: "ar-BH", Value: "Bahrain" },
        { Key: "ar-DZ", Value: "Algeria" },
        { Key: "ar-EG", Value: "Egypt" },
        { Key: "ar-IQ", Value: "Iraq" },
        { Key: "ar-JO", Value: "Jordan" },
        { Key: "ar-KW", Value: "Kuwait" },
        { Key: "ar-LB", Value: "Lebanon" },
        { Key: "ar-LY", Value: "Libya" },
        { Key: "ar-MA", Value: "Morocco" },
        { Key: "ar-OM", Value: "Oman" },
        { Key: "ar-QA", Value: "Qatar" },
        { Key: "ar-SA", Value: "Saudi Arabia" },
        { Key: "ar-SY", Value: "Syria" },
        { Key: "ar-TN", Value: "Tunisia" },
        { Key: "ar-YE", Value: "Yemen" },
        { Key: "be-BY", Value: "Belarus" },
        { Key: "bg-BG", Value: "Bulgaria" },
        { Key: "cs-CZ", Value: "Czech Republic" },
        { Key: "da-DK", Value: "Denmark" },
        { Key: "de-AT", Value: "Austria" },
        { Key: "de-CH", Value: "Switzerland (German)" },
        { Key: "de-DE", Value: "Germany" },
        { Key: "de-LI", Value: "Liechtenstein" },
        { Key: "dv-MV", Value: "Maldives" },
        { Key: "el-GR", Value: "Greece" },
        { Key: "en-AU", Value: "Australia" },
        { Key: "en-BZ", Value: "Belize" },
        { Key: "en-CA", Value: "Canada" },
        { Key: "en-CB", Value: "Caribbean" },
        { Key: "en-GB", Value: "United Kingdom" },
        { Key: "en-IE", Value: "Ireland" },
        { Key: "en-JM", Value: "Jamaica" },
        { Key: "en-NZ", Value: "New Zealand" },
        { Key: "en-PH", Value: "Philippines" },
        { Key: "en-TT", Value: "Trinidad and Tobago" },
        { Key: "en-US", Value: "USA" },
        { Key: "en-ZA", Value: "South Africa" },
        { Key: "en-ZW", Value: "Zimbabwe" },
        { Key: "es-AR", Value: "Argentina" },
        { Key: "es-BO", Value: "Bolivia" },
        { Key: "es-CL", Value: "Chile" },
        { Key: "es-CO", Value: "Colombia" },
        { Key: "es-CR", Value: "Costa Rica" },
        { Key: "es-DO", Value: "Dominican Republic" },
        { Key: "es-EC", Value: "Ecuador" },
        { Key: "es-ES", Value: "Spain" },
        { Key: "es-GT", Value: "Guatemala" },
        { Key: "es-HN", Value: "Honduras" },
        { Key: "es-MX", Value: "Mexico" },
        { Key: "es-NI", Value: "Nicaragua" },
        { Key: "es-PA", Value: "Panama" },
        { Key: "es-PE", Value: "Peru" },
        { Key: "es-PR", Value: "Puerto Rico" },
        { Key: "es-PY", Value: "Paraguay" },
        { Key: "es-SV", Value: "El Salvador" },
        { Key: "es-UY", Value: "Uruguay" },
        { Key: "es-VE", Value: "Venezuela" },
        { Key: "et-EE", Value: "Estonia" },
        { Key: "fa-IR", Value: "Iran" },
        { Key: "fi-FI", Value: "Finland" },
        { Key: "fo-FO", Value: "Faroe Islands" },
        { Key: "fr-BE", Value: "Belgium" },
        { Key: "fr-CA", Value: "Canada (French)" },
        { Key: "fr-CH", Value: "Switzerland (French)" },
        { Key: "fr-FR", Value: "France" },
        { Key: "fr-LU", Value: "Luxembourg" },
        { Key: "fr-MC", Value: "Monaco" },
        { Key: "he-IL", Value: "Israel" },
        { Key: "hi-IN", Value: "India" },
        { Key: "hr-HR", Value: "Croatia" },
        { Key: "hu-HU", Value: "Hungary" },
        { Key: "hy-AM", Value: "Armenia" },
        { Key: "id-ID", Value: "Indonesia" },
        { Key: "is-IS", Value: "Iceland" },
        { Key: "it-CH", Value: "Switzerland (Italian)" },
        { Key: "it-IT", Value: "Italy" },
        { Key: "ja-JP", Value: "Japan" },
        { Key: "ka-GE", Value: "Georgia" },
        { Key: "kk-KZ", Value: "Kazakhstan" },
        { Key: "ko-KR", Value: "South Korea" },
        { Key: "ky-KZ", Value: "Kyrgyzstan" },
        { Key: "lt-LT", Value: "Lithuania" },
        { Key: "lv-LV", Value: "Latvia" },
        { Key: "mn-MN", Value: "Mongolia" },
        { Key: "ms-BN", Value: "Brunei Darussalam" },
        { Key: "ms-MY", Value: "Malaysia" },
        { Key: "nb-NO", Value: "Norway (Bokmål)" },
        { Key: "nl-BE", Value: "Belgium (Dutch)" },
        { Key: "nl-NL", Value: "Netherlands" },
        { Key: "nn-NO", Value: "Norway (Nynorsk)" },
        { Key: "pl-PL", Value: "Poland" },
        { Key: "pt-BR", Value: "Brazil" },
        { Key: "pt-PT", Value: "Portugal" },
        { Key: "ro-RO", Value: "Romania" },
        { Key: "ru-RU", Value: "Russia" },
        { Key: "sk-SK", Value: "Slovakia" },
        { Key: "sl-SI", Value: "Slovenia" },
        { Key: "sq-AL", Value: "Albania" },
        { Key: "sv-FI", Value: "Finland (Swedish)" },
        { Key: "sv-SE", Value: "Sweden" },
        { Key: "sw-KE", Value: "Kenya" },
        { Key: "th-TH", Value: "Thailand" },
        { Key: "tr-TR", Value: "Turkiye" },
        { Key: "uk-UA", Value: "Ukraine" },
        { Key: "ur-PK", Value: "Pakistan" }
    ];
    options.sort((a, b) => { return a.Value.localeCompare(b.Value); });
    if (inheritFrom) {
        options.unshift({ Key: "-", Value: "-" });
        options.unshift({ Key: "", Value: `Inherit from ${inheritFrom}` });
    }
    return options;
}

export function parseDecimal(value, locale, decimals) {
    const formatter = new Intl.NumberFormat(locale);
    const parts = formatter.formatToParts(-12345.67);
    const decimal = parts.find(part => part.type === "decimal")?.value || ".";
    const group = parts.find(part => part.type === "group")?.value || ",";
    const replaced = value.toString().trim().replace(" ", "").replace(group, "").replace(decimal, ".");
    const cleaned = replaced.replace(/[^\d.-]/g, "");
    const decimalValue = parseFloat(cleaned);
    return isNaN(decimalValue) ? 0 : decimalValue.toFixed(decimals);
}

export function getDecimalMark(locale) {
    if (!locale) return ".";
    const formatter = new Intl.NumberFormat(locale);
    const parts = formatter.formatToParts(-12345.67);
    return parts.find(part => part.type === "decimal")?.value || ".";
}

export function formatCurrency(value, currency, locale) {
    if (!currency) {
        // if there is no currency, then display the value as a decimal with 2 digits - should be OK for 97.3% of currencies
        return formatQuantity(value, 2, locale);
    }
    return new Intl.NumberFormat(locale || DEFAULT_LOCALE, {
        style: "currency",
        currency: currency
    }).format(parseFloat(value));
}

export function formatQuantity(value, decimals, locale) {
    return new Intl.NumberFormat(locale || DEFAULT_LOCALE, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(parseFloat(value));
}

export function formatPercentage(value, decimals, locale) {
    return new Intl.NumberFormat(locale || DEFAULT_LOCALE, {
        style: "percent",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(parseFloat(value));
}

export function formatInteger(value, locale) {
    return new Intl.NumberFormat(locale || DEFAULT_LOCALE, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(parseFloat(value));
}

// A date coming off an API is one of two different things wearing the same clothes:
//
//  - a wall-clock date - "2026-08-11", or "2026-08-11T09:00:00" with no zone. It means that calendar
//    day (and that reading on the clock) for everyone, and must never be shifted by a timezone.
//  - a real instant - anything ending in "Z" or an offset. That one does need converting into the
//    reader's zone before it can be shown.
//
// Date-only strings are the trap. The spec parses them as UTC midnight, so reading their parts back
// with getFullYear()/getMonth()/getDate() - which answer in local time - lands a day early anywhere
// west of UTC: "2026-08-11" renders as 8/10/2026.
const EXPLICIT_TIME_ZONE = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const WALL_CLOCK_PARTS = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T ](\d{1,2}):(\d{2})(?::(\d{2}))?)?/;

function hasExplicitTimeZone(value) {
    return typeof value === "string" && EXPLICIT_TIME_ZONE.test(value.trim());
}

// Pins a zone-less value to the UTC instant that reads the same on the clock, so formatting it in UTC
// prints back the parts that were written down - no shifting in either direction.
function toWallClockInstant(value) {
    if (value instanceof Date) {
        return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(),
            value.getHours(), value.getMinutes(), value.getSeconds()));
    }
    const parts = WALL_CLOCK_PARTS.exec(value.toString().trim());
    if (parts) {
        return new Date(Date.UTC(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]),
            Number(parts[4] || 0), Number(parts[5] || 0), Number(parts[6] || 0)));
    }
    // Something we do not recognise - a locale-formatted string, say. Fall back to the engine's parse
    // and re-stamp its local reading, which is what the callers used to do for every value.
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) return null;
    return new Date(Date.UTC(parsed.getFullYear(), parsed.getMonth(), parsed.getDate(),
        parsed.getHours(), parsed.getMinutes(), parsed.getSeconds()));
}

// Resolves a value to { date, timeZone } ready to hand to Intl: a wall-clock value is formatted in UTC
// against its pinned instant, a real instant in the reader's zone.
function getDateFormatParts(value, timeZone) {
    if (hasExplicitTimeZone(value)) {
        const instant = new Date(value);
        if (isNaN(instant.getTime())) return null;
        return { date: instant, timeZone: timeZone || "UTC" };
    }
    const date = toWallClockInstant(value);
    return date ? { date, timeZone: "UTC" } : null;
}

export function formatDateValue(value, locale, timeZone) {
    if (!value) return "";
    const parts = getDateFormatParts(value, timeZone);
    if (!parts) return "";
    return parts.date.toLocaleDateString(locale || DEFAULT_LOCALE, { timeZone: parts.timeZone });
}

export function formatTimeValue(value, locale, timeZone) {
    if (!value) return "";
    const parts = getDateFormatParts(value, timeZone);
    if (!parts) return "";
    return parts.date.toLocaleTimeString(locale || DEFAULT_LOCALE, { timeZone: parts.timeZone });
}

export function formatDateTimeValue(value, locale, timeZone) {
    if (!value) return "";
    const parts = getDateFormatParts(value, timeZone);
    if (!parts) return "";
    const options = { timeZone: parts.timeZone };
    return `${parts.date.toLocaleDateString(locale || DEFAULT_LOCALE, options)} ${parts.date.toLocaleTimeString(locale || DEFAULT_LOCALE, options)}`;
}

export function formatDate(value, locale) {
    if (value instanceof Date) {
        if (locale) {
            return new Intl.DateTimeFormat(locale).format(value);
        }
        return new Intl.DateTimeFormat().format(value);
    } else {
        const dateValue = Date.parse(value);
        if (dateValue) {
            if (locale) {
                return new Intl.DateTimeFormat(locale, { timeZone: "UTC" }).format(dateValue);
            }
            return new Intl.DateTimeFormat("default", { timeZone: "UTC" }).format(dateValue);
        }
        return null;
    }
}